module.exports = __webpack_public_path__ + "static/img/ba.e18af32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/ba.jpg
// module id = Sq3b
// module chunks = 0